import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  trackClickForbiddenTextPopupButton,
  trackClickForbiddenTextPopupLink,
  trackCloseForbiddenTextPopup,
} from './tracking';
import { setEditableMessage } from '../../actions/chat/actions';
import { hostTypeSelector, TCurrentOpenedChat } from '../../selectors';
import { hideAlert } from '../../slices/alertSlice';
import { EDeviceType } from '../../types/deviceType';
import { EHostType } from '../../types/hostType';

type THandlerProps = {
  message?: string;
  chatId?: string;
  opponentId?: number;
  chat: TCurrentOpenedChat | null;
};

export const useForbiddenTextPopupHandler = ({ message, chatId, chat, opponentId }: THandlerProps) => {
  const dispatch = useDispatch();

  const hostType = useSelector(hostTypeSelector);
  const device = useDeviceType();

  const isIframe = hostType === EHostType.Frame;
  const isMobile = device !== EDeviceType.Desktop;

  const handleClose = React.useCallback(
    (isClickedSubmitButton?: boolean) => {
      dispatch(setEditableMessage({ text: message as string, chatId: chatId as string }));
      dispatch(hideAlert());
      if (isClickedSubmitButton) {
        trackClickForbiddenTextPopupButton(chat, opponentId);

        return;
      }
      trackCloseForbiddenTextPopup(chat, opponentId);
    },
    [chat, chatId, dispatch, message, opponentId],
  );

  const handleClickLinkButton = React.useCallback(() => {
    trackClickForbiddenTextPopupLink(chat, opponentId);
  }, [chat, opponentId]);

  return {
    handleCloseNoForbiddenTextPopup: handleClose,
    handleClickNoForbiddenTextPopupLink: handleClickLinkButton,
    isMobile: isMobile || isIframe,
  };
};
